import { TenorGif } from "../../types";
import BaseController from "./BaseController";

class GifsController extends BaseController {
  static getGifs(query?: string, next?: string): Promise<{
    next: string
    results: TenorGif[]
  }> {
    return this.post('messenger/gifs', { query: query, next: next });
  }
}

export default GifsController